import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import Player from '@vimeo/player';
import { PageService } from 'src/app/services/page.service';

@Component({
    selector: 'app-company-item',
    templateUrl: './company-item.component.html',
    styleUrls: ['./company-item.component.scss']
})
export class CompanyItemComponent implements OnInit {
    @Input() module;
    @Input() i: number;
    videourl: any;
    player: Player;
    isLoaded: boolean = false;
    animate: boolean = false;
    screenWidth: number = 0;
    screenHeight: number = 0;
    @ViewChild('videoplayer') videoplayer: ElementRef;
    dangerousUrl: any;
    rgb: string = '';
    not_suspend = true;
    imageLoaded = false;
    removeImage = false;
    notScrolled: boolean = false;
    scrolled: boolean = true;
    inViewPort: boolean = false;

    constructor(private sanitizer: DomSanitizer,
        private pageService: PageService) {
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
        this.screenHeight = window.innerHeight;
        if (this.module && this.inViewPort) {
            if (this.module.theme === 'dark') {
                this.pageService.whiteLogo(true);
            } else {
                this.pageService.whiteLogo(false);
            }
        }
    }

    ngOnInit(): void {
        setTimeout(() => {
            if (this.scrolled) {
                this.notScrolled = true;
            }
        }, 5000);
    }

    isLoadedComponent() {
        this.scrolled = false;
        this.notScrolled = false;
    }

    iframeLoaded() {
        setTimeout(() => {
            this.isLoaded = true;
        }, 0);

        if (this.screenWidth > 1024) {
            setTimeout(() => {
                this.removeImage = true;
                this.player.play();
            }, 1000);
        } else {
            setTimeout(() => {
                if (this.player) {
                    var promise = this.player.play();
                    if (promise !== undefined) {
                        promise.then(_ => {
                            this.player.play();
                            this.removeImage = true;
                        }).catch(error => {
                            this.not_suspend = false;
                            this.removeImage = false;
                        });
                    }
                }
            }, 2000);
        }
    }

    preIframeImageLoaded() {
        this.imageLoaded = true;
    }

    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            this.inViewPort = true;
            if (this.screenWidth <= 1024 && this.screenWidth > 768) {
                const activedots = document.getElementsByClassName('gallery-dots');
                for (let index = 0; index < activedots.length; index++) {
                    const activedot = activedots[index];
                    if (activedot.classList.contains('active')) {
                        activedot.classList.remove('active');
                    }
                }
                document.getElementById('gallery-dot-' + this.i).classList.add('active');
                if (this.module.theme === 'dark') {
                    if (!document.getElementById('dots-wrapper').classList.contains('white-dots')) {
                        document.getElementById('dots-wrapper').classList.add('white-dots');
                    }
                    if (document.getElementById('dots-wrapper').classList.contains('dark-dots')) {
                        document.getElementById('dots-wrapper').classList.remove('dark-dots');
                    }
                } else {
                    if (!document.getElementById('dots-wrapper').classList.contains('dark-dots')) {
                        document.getElementById('dots-wrapper').classList.add('dark-dots');
                    }
                    if (document.getElementById('dots-wrapper').classList.contains('white-dots')) {
                        document.getElementById('dots-wrapper').classList.remove('white-dots');
                    }
                }
            }
            if (this.module.theme === 'dark') {
                this.pageService.whiteLogo(true);
            } else {
                this.pageService.whiteLogo(false);
            }
            this.animate = true;
            setTimeout(() => {
                if (!this.player) {
                    if (this.screenWidth > 1024) {
                        this.dangerousUrl = 'https://player.vimeo.com/video/' + this.module.video_id + '?autoplay=0&loop=1&autopause=0&background=1&byline=0&portrait=0&muted=1';
                    } else {
                        this.dangerousUrl = 'https://player.vimeo.com/video/' + this.module.video_id_mobile + '?autoplay=0&loop=1&autopause=0&background=1&byline=0&portrait=0&muted=1';
                    }
                    this.videourl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dangerousUrl);

                    setTimeout(() => {
                        this.player = new Player(this.videoplayer.nativeElement);
                        this.player.on('timeupdate', function (data) {
                            this.videoprogress = (data.percent * 100);
                        })
                    }, 200);
                } else {
                    this.player.play();
                    this.player.on('timeupdate', function (data) {
                        this.videoprogress = (data.percent * 100);
                    })
                }
            }, 800);
        } else {
            this.inViewPort = false;
            if (this.player) {
                if (this.player.videoprogress > 0) {
                    this.player.pause();
                }
            }
        }
    }
}
